import React, { useCallback, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { withTranslation } from 'react-i18next';
import { ErrorBoundary, H1Title, ToggleMode } from '../../components';
import { useMode } from '../../context';
import { getAllProductCategories } from '../matching/service';
import CategoriesTable from './CategoriesTable';

const Categories = ({ t }) => {
    const { mode } = useMode();

    const [categoriesData, setCategoriesData] = useState([]);
    const [toDisplayCategories, setToDisplayCategories] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [filters, setFilters] = useState({
        categoryName: '',
        activePageReset: false,
    });

    const fetchData = useCallback(() => {
        setIsLoading(true);
        getAllProductCategories(mode).then(({ data }) => {
            let categories = [];
            if (data && data.length) {
                categories = data?.map((categoryName, id) => ({
                    id,
                    categoryName,
                }));
            }
            setToDisplayCategories(categories);
            setCategoriesData(categories);
            setIsLoading(false);
        });
    }, [mode]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const filterCategories = useCallback(
        ({ debouncedFilters }) => {
            const filteredCategories = categoriesData.filter((elem) =>
                elem.categoryName
                    .toLowerCase()
                    .includes(debouncedFilters.categoryName.toLowerCase()),
            );
            setToDisplayCategories(filteredCategories);
            setIsLoading(false);
        },
        [categoriesData],
    );

    return (
        <>
            <Helmet>
                <title>
                    {t('categories.metaTitle')} - {t('main.metaTitle')}
                </title>
            </Helmet>

            <H1Title title={t('categories.title')}>
                <ToggleMode />
            </H1Title>

            <ErrorBoundary>
                <CategoriesTable
                    data={toDisplayCategories}
                    handleRefreshData={fetchData}
                    filterCategories={filterCategories}
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                    filters={filters}
                    setFilters={setFilters}
                />
            </ErrorBoundary>
        </>
    );
};

export default withTranslation('common')(Categories);
